var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "itemsRow d-flex", class: { section: _vm.isSection } },
    [
      _c(
        "v-list-item",
        {
          key: _vm.item.id,
          staticStyle: { "flex-grow": "2" },
          on: {
            "&click": function ($event) {
              return _vm.clickBox(_vm.item, $event)
            },
          },
        },
        [
          _vm.item.section
            ? _c("v-list-item-content", [
                _c("div", { staticClass: "isection d-flex" }, [
                  _vm.item.sectionContent.indexOf("data-prefix") !== -1
                    ? _c(
                        "div",
                        { staticClass: "prefix" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "myAccent mr-1",
                              attrs: { "x-large": "" },
                            },
                            [_vm._v("mdi-star")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", {
                    staticClass: "fontColor",
                    class: {
                      styled: _vm.item.sectionContent.indexOf("<") !== -1,
                    },
                    staticStyle: { "align-self": "center" },
                    domProps: { innerHTML: _vm._s(_vm.item.sectionContent) },
                  }),
                ]),
              ])
            : _c("v-list-item-content", [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    {
                      staticClass: "prelative tileImgCol",
                      class: {
                        withImage:
                          _vm.imgSource.length > 0 &&
                          (_vm.imgSource.indexOf("placeholder6") === -1 ||
                            _vm.$store.state.showPlaceholders),
                      },
                    },
                    [
                      _vm.imgSource.length === 0 ? _c("div") : _vm._e(),
                      _vm.imgSource.length > 0 &&
                      (_vm.imgSource.indexOf("placeholder6") === -1 ||
                        _vm.$store.state.showPlaceholders)
                        ? _c("div", { staticClass: "prelative" }, [
                            _c("img", {
                              staticClass: "tileImg",
                              class: {
                                withPlaceholder:
                                  _vm.imgSource.includes("placeholder"),
                                forDrinks: _vm.fordrinks,
                              },
                              attrs: {
                                alt: _vm.$store.state.brandName,
                                src: _vm.imgSource,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.clickImage.apply(null, arguments)
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "verticalFlex",
                      class: {
                        withImage:
                          _vm.imgSource.length > 0 &&
                          _vm.imgSource.indexOf("placeholder") === -1,
                      },
                    },
                    [
                      _c("div", { staticClass: "dd-texts" }, [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", [
                            _vm.item.neu
                              ? _c("span", { staticClass: "stoerer mr-2" }, [
                                  _vm._v("NEU"),
                                ])
                              : _vm._e(),
                            _c("h3", {
                              staticClass:
                                "itemTitle headColor d-inline hyphens",
                              domProps: { innerHTML: _vm._s(_vm.item.nameDE) },
                            }),
                            _vm.item.substances && _vm.item.substances.lAlk
                              ? _c("span", [
                                  _c(
                                    "sup",
                                    {
                                      staticClass: "alk",
                                      class: { bgLight: _vm.bgLight },
                                    },
                                    [_vm._v("mit Alkohol")]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm.$store.state.enableFavs &&
                          (_vm.isFavorite || _vm.expanded)
                            ? _c(
                                "div",
                                { staticClass: "heart d-inline-block" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "rounded100",
                                      staticStyle: {
                                        width: "35px",
                                        height: "35px",
                                        "margin-top": "-4px",
                                      },
                                      attrs: { dark: "", icon: "" },
                                      nativeOn: {
                                        "&click": function ($event) {
                                          $event.stopPropagation()
                                          return _vm.switchFavorite.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.isFavorite
                                        ? _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                medium: "",
                                                color: "red",
                                              },
                                            },
                                            [_vm._v("mdi-heart")]
                                          )
                                        : _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                medium: "",
                                                color: "#888888",
                                              },
                                            },
                                            [_vm._v("mdi-heart-outline")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "fontColor textFont pt-2 limitedGrow",
                          },
                          [
                            _c("div", [
                              _vm.expanded
                                ? _c("div", {
                                    staticClass: "breakable",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.item.descriptionDE),
                                    },
                                  })
                                : _c("div", { staticClass: "twoLiner" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("noHtml")(_vm.item.descriptionDE)
                                      )
                                    ),
                                  ]),
                              _vm.$store.state.enableBestand &&
                              _vm.$store.state.enableBestandanzeigeInItemList &&
                              _vm.item.bestand &&
                              _vm.item.bestand > 0
                                ? _c("div", [
                                    _vm._v(
                                      " Bestand: " +
                                        _vm._s(_vm.item.bestand) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        !_vm.buyable
                          ? _c(
                              "div",
                              { staticClass: "notAvailable pt-2" },
                              [
                                _vm.item.redAvailabilityInfo
                                  ? [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.redAvailabilityInfo)
                                        ),
                                      ]),
                                    ]
                                  : [
                                      !_vm.item.buyable
                                        ? _c("span", [
                                            _vm._v(
                                              "Der Artikel ist nicht online bestellbar"
                                            ),
                                          ])
                                        : _vm.$store.getters.inhouse &&
                                          !_vm.item.buyableForInhouse
                                        ? _c("span", [
                                            _vm._v(
                                              "Der Artikel ist Inhouse nicht bestellbar"
                                            ),
                                          ])
                                        : !_vm.$store.getters.inhouse &&
                                          !!_vm.item.buyableForInhouse
                                        ? _c("span", [
                                            _vm._v(
                                              "Der Artikel ist nur Inhouse bestellbar"
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Der Artikel ist nicht online bestellbar"
                                            ),
                                          ]),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                      _c("div", { staticStyle: { "flex-grow": "1" } }),
                      _vm.item.sizes
                        ? _c("div", { staticClass: "dd-preise pt-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: { "flex-direction": "column" },
                              },
                              [
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm.hasReplaceArticle
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "fontColor maxw preis",
                                                class: {
                                                  actualPrice:
                                                    _vm.item.streichPreis,
                                                },
                                              },
                                              [
                                                _vm.item.streichPreis
                                                  ? _c("span", [_vm._v("✨")])
                                                  : _vm._e(),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("basePrice")(
                                                      _vm.item
                                                    )
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._l(
                                            _vm.item.sizes,
                                            function (size) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass: "d-flex",
                                                  staticStyle: {
                                                    "line-height": "1.5em",
                                                  },
                                                },
                                                [
                                                  size.vol
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fontColor itemSubtitle mr-4 text-no-wrap",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(size.vol)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.$store.getters.hidePrices
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fontColor maxw preis",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "priceTotal"
                                                              )(size.price)
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                      _vm.item.streichPreis
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "streichPreisCrossed ml-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "schraeger-text",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("priceTotal")(
                                                          _vm.item.streichPreis
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                _vm.item.kilopreis
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ml-3 secondaryFontColor smallText",
                                      },
                                      [_vm._v(_vm._s(_vm.item.kilopreis))]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "prelative",
                    staticStyle: { "max-height": "0" },
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      !_vm.item.section
                        ? _c("div", { staticStyle: { "flex-shrink": "0" } }, [
                            _vm.buyable
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "plusBox",
                                    on: {
                                      "&click": function ($event) {
                                        $event.stopPropagation()
                                        return _vm.clickItem(_vm.item)
                                      },
                                    },
                                  },
                                  [
                                    _vm.expanded
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "myAccent",
                                            staticStyle: {
                                              "margin-bottom": "2px",
                                            },
                                            attrs: { "x-large": "" },
                                          },
                                          [_vm._v("mdi-close-box")]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            staticClass: "myAccent",
                                            attrs: { "x-large": "" },
                                          },
                                          [_vm._v("mdi-plus-box")]
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm.expanded
                  ? _c("div", [
                      _vm.item.gramm
                        ? _c("div", { staticClass: "d-flex align-center" }, [
                            _vm.item.gram
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.item.gramm) + "g"),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm.item.cmRatio
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("v-icon", [_vm._v("mdi-corn")]),
                              _vm._v(
                                " Getreidemischverhältnis: " +
                                  _vm._s(_vm.item.cmRatio) +
                                  " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.item.days && _vm.$store.state.showItemDaysAvailability
                        ? _c("div", { staticClass: "pt-2" }, [
                            _vm._v(
                              " Verfügbarkeit: " +
                                _vm._s(_vm._f("displayDays")(_vm.item.days)) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
        ],
        1
      ),
      _vm.showItemDetail && _vm.currentItem.id
        ? _c("div", { staticClass: "invisibleDetail" }, [
            _vm.fordrinks
              ? _c(
                  "div",
                  [
                    _c("DrinkItemDetail", {
                      attrs: {
                        "add-directly": false,
                        itemId: _vm.currentItem.id,
                      },
                      on: {
                        wasAdded: function ($event) {
                          _vm.showItemDetail = false
                        },
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("ItemDetail", {
                      attrs: {
                        "add-directly": false,
                        itemId: _vm.currentItem.id,
                      },
                      on: {
                        wasAdded: function ($event) {
                          _vm.showItemDetail = false
                        },
                      },
                    }),
                  ],
                  1
                ),
          ])
        : _vm._e(),
      _vm.fullImageSrc.length > 0
        ? _c(
            "div",
            {
              staticClass: "fullImage superCenter",
              class: { isMobile: _vm.isMobile },
              on: {
                "&click": function ($event) {
                  $event.stopPropagation()
                  _vm.fullImageSrc = ""
                },
              },
            },
            [
              _vm.fullImageSrc.length > 0
                ? _c("img", {
                    key: _vm.fullImageSrc,
                    staticClass: "rImg",
                    class: { doFade: _vm.fullImageSrc.length > 0 },
                    attrs: { src: _vm.fullImageSrc },
                  })
                : _vm._e(),
              _c("div", { staticClass: "tip pointer" }, [
                _c(
                  "div",
                  { staticClass: "pt-1 pb-1" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "myWhite", attrs: { big: "" } },
                      [_vm._v("mdi-close")]
                    ),
                  ],
                  1
                ),
                _c("h3", { staticStyle: { color: "white" } }, [
                  _vm._v("TAP TO CLOSE "),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }